<template>
  <div class="detail">
    <van-sticky>
      <vannav></vannav>
    </van-sticky>
    <van-pull-refresh
      v-model="isLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <!-- :offset="10" -->

        <textbox :datalist="datalist"></textbox>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { selectWarnLogPage } from "@/api/usesafely";
import textbox from "../components/textbox.vue";
import { Toast, Notify } from "vant";
export default {
  components: { textbox },
  data() {
    return {
      datalist: [],
      list: [],
      isLoading: false,
      loading: false,
      finished: false,
      current: 1,
      size: 10,
      timer: null,
      total: null
    };
  },
  activated() {
    if (this.$store.getters.getinfosafely.tag == true) {
      this.datalist[
        this.$store.getters.getinfosafely.index
      ].remark = this.$store.getters.getinfosafely.remark;
      this.datalist[
        this.$store.getters.getinfosafely.index
      ].status = this.$store.getters.getinfosafely.status;
    }
  },
  mounted() {
    this.datalist = [];
    this.getselectWarnLogPage(this.current, this.size);
  },
  methods: {
    onLoad() {
      clearTimeout(this.timer);
      this.loading = true;
      this.timer = setTimeout(() => {
        // 因为没有值就先不加载了
        // if (this.current) return;
        // 加载状态结束
        this.finished = false;
        this.current++;
        this.getselectWarnLogPage(this.current, this.size);
      }, 1000);
    },
    // 下拉刷新
    onRefresh() {
      //   清空数据
      Toast("刷新成功");
      this.datalist = [];
      this.current = 1;
      this.size = 10;
      this.finished = false;
      this.getselectWarnLogPage(this.current, this.size);
      this.isLoading = false;
    },
    getselectWarnLogPage(current, size) {
      selectWarnLogPage(this.$token, current, size).then(res => {
        if (res.data.code == 200) {
          const rows = res.data.data.records;
          this.total = res.data.data.total;
          // this.current = res.data.data.current;
          this.size = res.data.data.size;

          if (rows === null || rows.length === 0) {
            // 加载结束
            this.finished = true;
            return false;
          }
          this.datalist = this.datalist.concat(rows);
          this.loading = false;
          //  如果列表数据条数>=总条数，不再触发滚动加载
          if (this.datalist.length >= this.total) {
            this.finished = true;
          }
        } else {
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.detail {
  background-color: #f5f5f5;
  height: 100%;
  overflow: auto;
}
.van-pull-refresh {
  margin-top: 0;
  height: 93%;
  overflow: auto;
}
</style>
